import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { GridComponent, SearchSettingsModel, ToolbarItems, PageSettingsModel, FilterSettingsModel, IFilter, DataStateChangeEventArgs, QueryCellInfoEventArgs } from '@syncfusion/ej2-angular-grids';
import { ChangeEventArgs } from '@syncfusion/ej2-angular-inputs';
import { Tooltip } from '@syncfusion/ej2-angular-popups';
import { DropDownList } from '@syncfusion/ej2-dropdowns';
import { IMultiSelectSettings, IMultiSelectOption } from 'angular-2-dropdown-multiselect';
import { ToastrService } from 'ngx-toastr';
import { Subject, Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { GlobalComponent } from 'src/app/global/global.component';
import { functionpermission, WhereCondition } from '../client-parent/client-parent.model';
import { columnWidth, ColumnChangeBO } from '../employee/employee.model';
import { sortingObj } from '../list/list.model';
import { filterpair, GetICD10BO, ICD10List } from './icd10.model';
import { CommonHttpService } from 'src/app/common.service';
import { ICD10Service } from './icd10.service';
declare var $: any;

@Component({
  selector: 'app-icd10',
  templateUrl: './icd10.component.html',
  styleUrls: ['./icd10.component.scss']
})

export class ICD10Component implements OnInit {
  isSaveorUpdateBoolean:boolean=false;
  @ViewChild('grid') public grid: GridComponent;
  private onDestroy$: Subject<void> = new Subject<void>();
  @Input() ICD10input: string;
  @Output() dataFromICD10 = new EventEmitter<number>();
  title = 'ng-bootstrap-modal-demo';
  closeResult: string;
  modalOptions: NgbModalOptions = {
    size: 'sm', windowClass: 'modal-xs', container: '.session-modal-container'
  };
  icd10Array: ICD10List[];
  icd10: ICD10List = new ICD10List();
  confirmCancel: boolean
  Icd10DataList: any = [];
  ColumnArray: columnWidth[]
  columnchange: ColumnChangeBO = new ColumnChangeBO();
  id: number = 0;
  arraycol: any = [];
  icd10Form: FormGroup;
  SearchText: string = '';
  SearchColumn: { key: string, value: string } = {
    key: 'Code', value: 'Code',
  };
  SearchColumns: string = 'Code';
  dropInstance: DropDownList;
  public searchSettings: SearchSettingsModel;
  public toolbar: ToolbarItems[];
  initialPage: PageSettingsModel;
  filterOptions: FilterSettingsModel;
  clientview: boolean = false;
  filter: IFilter;
  TotalCount: number;
  pagshort: sortingObj = new sortingObj();
  ModelType: string = 'edit';
  EmployeeTypeList: [{ key: string, value: string }];
  filterItems: filterpair[] = []
  SearchTextICD: string = "";
  pageNOIcd: number = 1;
  getICD10CodesErr: any = '';
  columnsSettings: IMultiSelectSettings = {
    enableSearch: true,
    checkedStyle: 'checkboxes',
    buttonClasses: 'fa fa-cog btn blue-btn btn-lg text-white',
    dynamicTitleMaxItems: 0,
    displayAllSelectedText: false,
    fixedTitle: false,
  };
  columns: IMultiSelectOption[] = [
    { id: 'ID', name: 'ID' },
    { id: 'Code', name: 'Code' },
    { id: 'ICD10 Level', name: 'ICD10 Level' },
    { id: 'ICD10 Description', name: 'ICD10 Description' },
    { id: 'Actions', name: 'Actions' },
  ];
  public filterSettings: object;
  public pageSizes: number[] = [10, 15, 20, 50, 100, 250];
  public isinitialLoad: boolean = false;
  public state: DataStateChangeEventArgs;
  ICD10List: any;
  cancelConfirm: boolean;
  valuechange: any = [];
  deleteError: any = "";
  deleteAlert: boolean = false;
  saveError: any = "";
  saveAlert: boolean = false
  ListSendBO: GetICD10BO = new GetICD10BO();
  public data: any;

  constructor(public http: HttpClient, private formBuilder: FormBuilder, public global: GlobalComponent,
    public toastrService: ToastrService, public commonSvc: CommonHttpService, public icd10Service: ICD10Service) {
    this.icd10Form = this.formBuilder.group({
      code: ['', Validators.required],
      icD10Level: [''],
      icD10Description: [''],
    });
    this.data = icd10Service;
  }
  type: string = "";
  public dataStateChange(state): void {
    this.type = (state.action.requestType).toString();
    if (this.type != "filterchoicerequest") {
      if ((state.sorted || []).length) {
        this.ListSendBO.orderColumn = state.sorted[0].name;
        this.ListSendBO.orderType = state.sorted[0].direction === 'descending' ? 'DESC' : 'ASC';
      }
    }
    if (this.type == "filtering" && state.action.action != "clearFilter") {
      this.ListSendBO.field = state.action.currentFilterObject.field;
      this.ListSendBO.matchCase = state.action.currentFilterObject.matchCase;
      this.ListSendBO.operator = state.action.currentFilterObject.operator;
      this.ListSendBO.value = state.action.currentFilterObject.value;
    }
    else {
      if (this.type == "filtering" && state.action.action == "clearFilter") {
        this.ListSendBO.field = "code";
        this.ListSendBO.matchCase = false;
        this.ListSendBO.operator = "startswith";
        this.ListSendBO.value = "";
      }
      if (this.type == "paging" && state.action.name == "actionBegin") {
        if (this.arraycol.length != 0) {
          if (this.arraycol[0].ICD10.Pagesize != state.take) {
            this.arraycol[0].ICD10.Pagesize = state.take
            // this.SaveColumnwidth();
          }
        }
      }
    }
    this.getIcd10Codes();
  }
  ngOnInit(): void {
    console.log(this.ICD10input, 'clientview')
    this.filterItems = [{ key: 'Code', value: 'Code' },
    { key: 'ICD10Level', value: 'ICD10 Level' },
    { key: 'ICD10Description', value: 'ICD10 Description' }];
    this.SearchColumn.key = 'Code';
    this.SearchColumn.value = 'Code';
    if (this.ICD10input == "client") {
      this.clientview = true;
    }
    this.toolbar = ['ColumnChooser'];
    this.filterSettings = { type: 'Menu' };
    this.initialPage = { pageSizes: ['10', '20', '50', '100', '250'], pageSize: 10 };
    this.getIcd10Codes();
  }

  change(args: ChangeEventArgs) {
    this.initialPage = { currentPage: args.value };
  }

  public onActionComplete(args) {
    this.ListSendBO.currentpageno = this.grid.pagerModule.pagerObj.currentPage;
    this.ListSendBO.pageitem = this.grid.pagerModule.pagerObj.pageSize;
    if (args.requestType == "columnstate") {
      let hidearr = [];
      let showarr = [];
      this.grid.columns.forEach(element => {
        if (element.visible == false && element.headerText != "Actions" && element.headerText != "") {
          hidearr.push(element.headerText);
        }
        if (element.visible == true && element.headerText != "Actions" && element.headerText != "") {
          showarr.push(element.headerText);
        }
      })
      var count = 0;
      var count1 = 0;
      if (args.columns.length > 0) {

        this.arraycol[0].ICD10.ShowColumns.forEach(old => {
          showarr.forEach(element => {
            if (old == element) {
              count1 = count1 + 1;
            }
          });
        });
        this.arraycol[0].ICD10.HideColumns.forEach(old => {
          hidearr.forEach(element => {
            if (old == element) {
              count = count + 1;
            }
          });
        });
        if (this.arraycol[0].ICD10.ShowColumns.length != count1 || this.arraycol[0].ICD10.HideColumns.length != count) {
          this.arraycol[0].ICD10.ShowColumns = showarr;
          this.arraycol[0].ICD10.HideColumns = hidearr;
          // this.SaveColumnwidth();
        }
      }
    }
  }
  setDefaultValue(event) {
    this.SearchText = "";
    if (this.SearchColumn == undefined) {
      this.SearchColumn = {
        key: 'Code', value: 'Code',
      };
    }
    else {
      this.SearchColumn.value = this.filterItems.filter(f => f.key == event)[0].value
    }
  }

  //////////////////////////////// Search ,refresh and pagination Function////////////////////////////////////////////
  onKeydown(event) {
    if (event.key === "Enter") {
      this.Search();
    }
  }

  Search() {
    this.pagshort.currentPgNo = 1;
    this.ListSendBO.field = this.SearchColumn.key
    this.ListSendBO.value = this.SearchText
    this.getIcd10Codes();
  }

  Refresh() {
    this.SearchText = "";
    this.SearchColumn.key = 'Code';
    this.SearchColumn.value = 'Code';
    this.ListSendBO.field = 'Code'
    this.ListSendBO.value = ''
    this.pagshort = new sortingObj();
    this.getIcd10Codes();
    this.grid.clearFiltering();
    this.grid.clearSorting();
  }

  paginationChange(event) {
    this.pagshort.currentPgNo = event;
    this.getIcd10Codes();
  }

  // /////////////////////////////////////////////////////////////////
  pageItemsChage(pageitems) {
    this.pagshort.itemperpage = pageitems;
    this.getIcd10Codes();
  }

  /////////////////////////////////get icd10 Create and edit data////////////////////////////////////
  IcdCreateupdate(type: string) {
    if (type == 'new') {
      this.ModelType = 'new';
      this.icd10Form.reset();
      this.icd10 = new ICD10List();
    }
    else {
      this.ModelType = 'edit';

    }
    this.valueschanges()
  }

  getIcd10Codes() {
    let count = 0;
    this.icd10Service.execute(this.ListSendBO);
    this.data.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.Icd10DataList = data.result;
      count = count + 1
      if (data != null && data != undefined && count == 1) {
        if (this.global.globalAgencyId != 0) {
          // this.getColumnwidth();
        }
      }
    })
  }

  /////////////////////////////////Save and Update ICD10////////////////////////////////////
  SaveOrUpdateIcd10() {
    this.isSaveorUpdateBoolean=true;
    let url = "api/ICD10/SaveICD10";
    var saveList: ICD10List = JSON.parse(JSON.stringify(this.icd10));
    this.commonSvc.saveorUpdateFunctionwithResponseTypeJson(saveList, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: number) => {
      this.isSaveorUpdateBoolean=false;
      if (data) {
        //====================== sucess message =============
        if (this.ModelType == 'new') {
          saveList.id = data;
          this.getIcd10Codes()
          this.toastrService.success('ICD10 code saved successfully!')
          document.getElementById('openModal1').click();
        }
        else if (this.ModelType == 'edit') {
          this.getIcd10Codes()
          this.toastrService.success('ICD10 code updated successfully!')
          document.getElementById('openModal1').click();
        }
      }
    }, (err: any) => {
      this.isSaveorUpdateBoolean=false;
      if (err) {
        this.saveError = err;
        this.saveAlert = true
      }
      else {
        this.saveError = JSON.stringify(err);
      }
      if (this.saveError != "") {
        setTimeout(() => {
          this.saveError = "";
          this.saveAlert = false
        }, 5000)
      }
    }
    )
  }

  ////////////////////////////Delete ICD10/////////////////////////////
  deleteIcd10() {
    let url = "api/ICD10/DeleteICD10?";
    let params = new URLSearchParams();
    params.append("ICD10Id", this.icd10.id.toString());
    this.http.delete(url + params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.getIcd10Codes()
      this.toastrService.success("ICD10 code deleted successfully!")
      document.getElementById('openModal2').click();
    }
      , (err: any) => {
        document.getElementById('openModal2').click();
        if (err) {
          this.deleteError = err;
          this.deleteAlert = true
        }
        else {
          this.deleteError = JSON.stringify(err);
        }
        if (this.deleteError != "") {
          setTimeout(() => {
            this.deleteError = "";
            this.deleteAlert = false
          }, 5000)
        }
      }
    )
  }

  icdDetails(icd: ICD10List) {
    this.icd10 = icd;
    this.icd10 = JSON.parse(JSON.stringify(icd));
  }

  //////////////////////////////////value change///////////////////////////////////////
  valueschanges() {
    this.valuechange = {
      code: 0,
      icD10Level: 0,
      icD10Description: 0,
    }
  }

  checkpopup(value) {
    if (value == "code") {
      this.valuechange.code++;
    }
    if (value == "icD10Level") {
      this.valuechange.icD10Level++;
    } if (value == "icD10Description") {
      this.valuechange.icD10Description++;
    }
  }

  // ///////////////////////Cancel modal popup//////////////////////////////////////////
  cancel() {
    if (this.valuechange.code > 1 || this.valuechange.icD10Level > 1 || this.valuechange.lovValue > 1 ||
      this.valuechange.icD10Description > 1) {
      $('#CloseModal').modal({
        show: true,
        zIndex: 1000000
      })
      $(document).on('show.bs.modal', '.modal', function (event) {
        var zIndex = 10000000 + (1 * $('.modal:visible').length);
        $(this).css('z-index', zIndex);
        setTimeout(function () {
          $('.modal-backdrop').not('.modal-stack').css('z-index', zIndex - 1).addClass('modal-stack');
        }, 0);
      });
    }
    else {
      document.getElementById('modal').click();
    }
  }

  cancelYes() {
    document.getElementById('openModal1').click();
    document.getElementById('openModal3').click();
  }

  show() {
    this.grid.columnChooserModule.openColumnChooser(200, 50);
  }

  /////////////////////////////////client value change//////////////////////////////////////////
  valueselect(data) {
    this.dataFromICD10.emit(data)
    this.clientview = false;
  }

  //============================== Tooltip =========================================================//
  headerCellInfo(args) {
    const toolcontent = args.cell.column.headerText;
    const tooltip: Tooltip = new Tooltip({
      content: toolcontent
    });
    tooltip.appendTo(args.node);
  }

  tooltip(args: QueryCellInfoEventArgs) {
    if (args.column.field != null) {
      if (args.data[args.column.field] != null) {
        const tooltip: Tooltip = new Tooltip({
          content: args.data[args.column.field].toString(),
          position: 'RightCenter',
        }, args.cell as HTMLTableCellElement);
      }
    }
  }

  onResize(args) {
    if (this.ColumnArray != null && this.ColumnArray != undefined) {
      const column = this.grid.getColumnByField(args.column.field)
      column.width = args.column.width;
      this.ColumnArray.forEach(element => {
        if (element.column == column.headerText) {
          element.width = parseInt(column.width.toString());
        }
      });
      // this.SaveColumnwidth();
    }
  }

  getColumnwidth() {
    this.arraycol = JSON.parse(this.global.globalColumn.column);
    this.ColumnArray = this.arraycol[0].ICD10.Columns;
    this.grid.columns.forEach(col => {
      this.arraycol[0].ICD10.HideColumns.forEach(element => {
        if (col.headerText == element) {
          col.visible = false;
        }
      });
    });
    this.grid.showColumns(this.arraycol[0].ICD10.ShowColumns);
    this.grid.hideColumns(this.arraycol[0].ICD10.HideColumns);
    if (this.global.globalColumn.userid != null && this.global.globalColumn.agencyId != null) {
      this.id = this.global.globalColumn.id;
    }
    this.grid.pageSettings.pageSize = this.arraycol[0].ICD10.Pagesize
    this.ColumnArray.forEach(element => {
      if (element.column == 'Code') {
        const column = this.grid.getColumnByField('code');
        column.headerText = element.column;
        column.width = element.width;
        this.grid.refreshHeader();
      }
      if (element.column == 'ICD10 Level') {
        const column1 = this.grid.getColumnByField('icD10Level');
        column1.headerText = element.column;
        column1.width = element.width;
        this.grid.refreshHeader();
      }
      if (element.column == 'ICD10 Description') {
        const column2 = this.grid.getColumnByField('icD10Description');
        column2.headerText = element.column;
        column2.width = element.width;
        this.grid.refreshHeader();
      }
      else if (element.column == 'Actions') {
        const column3 = this.grid.getColumnByUid('action');
        column3.width = element.width;
        this.grid.refreshHeader();
      }
    });
  }

  closeCreateICD10() {
    document.getElementById('openModal1').click();
  }

  public ngOnDestroy(): void {
    this.onDestroy$.next();
  }
}
